// deps
import React, { memo, useRef } from "react";

// internal-deps
import { DialogHOC, useEffectOnce } from "@swiggy-private/core-ui";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { CloseIcon } from "@cart-ui/widgets/close-icon";

// constants
import { CLOSE_ICON, LABELS, TOING_POPUP_CONFIG } from "@cart-ui/components/toing-popup/constants";

// styles
import { Container, ContentContainer, ImageContainer, StyledCloseIcon, ButtonCTA, TimerContainer } from "./styles";

// test-ids
import { TOING_POPUP_TEST_IDS } from "@swiggy-private/cart-test-ids";

export interface ToingPopupProps {
    closeModal: (label?: string) => void;
    onImpressionToingPopup: () => void;
}

const ToingPopup: React.FC<ToingPopupProps> = ({ closeModal, onImpressionToingPopup }) => {
    const animationRef = useRef(null);

    const handleClose = (label?: string) => {
        closeModal(label);
    };

    useEffectOnce(() => {
        onImpressionToingPopup();
    });

    return (
        <Container data-testid={TOING_POPUP_TEST_IDS.CONTAINER}>
            <ContentContainer>
                <StyledCloseIcon data-testid={TOING_POPUP_TEST_IDS.CLOSE}>
                    <CloseIcon
                        onClick={() => handleClose(LABELS.CLOSE_CLICK)}
                        IconBgColor={CLOSE_ICON.color}
                        IconFillColor={CLOSE_ICON.fill}
                        size={CLOSE_ICON.size}
                    />
                </StyledCloseIcon>
                <ImageContainer data-testid={TOING_POPUP_TEST_IDS.IMAGE}>
                    <Image
                        cloudinaryId={TOING_POPUP_CONFIG.imageId}
                        height={TOING_POPUP_CONFIG.height}
                        width={TOING_POPUP_CONFIG.width}
                        alt={TOING_POPUP_CONFIG.alt}
                    />
                </ImageContainer>
            </ContentContainer>
            <ButtonCTA onClick={() => handleClose(LABELS.BUTTON_CLICK)} data-testid={TOING_POPUP_TEST_IDS.CTA}>
                <Text variant="V2.subheading1.neutral.medium" color="primary">
                    {TOING_POPUP_CONFIG.ctaText}
                </Text>
            </ButtonCTA>
            <TimerContainer ref={animationRef} onAnimationEnd={() => closeModal()} />
        </Container>
    );
};

export default DialogHOC(memo(ToingPopup));
